<template>
    <div class="wechat-key-wrap">
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" offset="18">
                    <el-tooltip class="item" effect="dark" content="点击查询" placement="right">
                        <el-button type="primary" size="mini" @click="getList">查询</el-button>
                    </el-tooltip>
                </el-col>
                <el-col :span="2">
                    <el-tooltip class="item" effect="dark" content="新增多套模板文案" placement="right">
                        <el-button type="success" size="mini" @click="add">新增</el-button>
                    </el-tooltip>
                </el-col>
            </el-row>
        </div>
        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="messageName" label="模板名称"></el-table-column>
            <el-table-column prop="first" label="头文本" width="180"></el-table-column>
            <el-table-column prop="topColor" label="头颜色" width="80"></el-table-column>
            <el-table-column prop="remark" label="尾文本" width="180"></el-table-column>
            <el-table-column prop="bottomColor" label="尾颜色" width="80"></el-table-column>
            <el-table-column prop="url" label="链接" width="180"></el-table-column>
            <el-table-column prop="execTypeName" label="执行类型" width="180"></el-table-column>
            <el-table-column prop="execTypeValue" label="类型值" width="180"></el-table-column>
            <el-table-column prop="creatTime" label="创建日期"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="status" label="状态" :formatter="statusProcess" sortable></el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button type="warning" size="mini" @click="handleDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.messageContentId></el-input>
                </el-form-item>
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.messageId></el-input>
                </el-form-item>
                <el-form-item label="模板名称">
                    <el-input v-model=form.messageName disabled="true" clearable placeholder="模板名称"></el-input>
                </el-form-item>
                <el-form-item label="头文本">
                    <el-input type="textarea"
                              :rows="5" v-model=form.first clearable placeholder="头文本"></el-input>
                </el-form-item>
                <el-form-item label="头颜色">
                    <el-input v-model=form.topColor clearable placeholder="头颜色"></el-input>
                </el-form-item>
                <el-form-item right>
                    <span style="color: red">值参照小程序(公众号)后台示例格式填写 (如要求是日期格式就不能写成汉字) 小程序限制值文案不能超过20个字符，超出后将不能被推送</span>
                </el-form-item>
                <el-form-item label="Body">
                    <el-table :data="body" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                              width="180">
                        <el-table-column type="index" label="序号" width="60">
                        </el-table-column>
                        <el-table-column prop="name" label="标题" width="180">
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.name disabled="disabled"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="title" label="Keyword" width="180">
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.title disabled="disabled"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="value" label="值">
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.value clearable
                                          placeholder="模板消息中右侧显示的内容(不要超过20个字)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="value" label="颜色">
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.color clearable placeholder="颜色"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="尾文本">
                    <el-input type="textarea"
                              :rows="5" v-model=form.remark clearable placeholder="尾文本"></el-input>
                </el-form-item>
                <el-form-item label="尾颜色">
                    <el-input v-model=form.bottomColor clearable placeholder="尾颜色"></el-input>
                </el-form-item>
                <el-form-item label="URL">
                    <el-input v-model="form.url" clearable
                              placeholder="连接参考 公众号连接 https://wx.lechun.cc 小程序连接: pages/home/index"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="form.sort" :min="1" :max="100" label="位数"
                                     placeholder="数字越小越靠前"></el-input-number>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select v-model="form.status" placeholder="状态">
                        <el-option v-for="item in statusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="执行时间">-->
                <!--<el-select v-model="form.execType"  placeholder="执行时间" >-->
                <!--<el-option v-for="item in execTypeList"-->
                <!--:key="item.id"-->
                <!--:label="item.name"-->
                <!--:value="item.id">-->
                <!--</el-option>-->
                <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item label="执行时间" v-show="form.execType==1">
                    <el-select v-model="form.execTypeValue" placeholder="执行时间">
                        <el-option v-for="item in execTypeValueList"
                                   :key="item.name"
                                   :label="item.name"
                                   :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getPlateMessageContentList,
        deletePlateMessageContent,
        savePlateMessageContent,
        getPlateMessageContent,
        getWeekList
    } from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                statusData: [{"id": 0, "name": "禁用"}, {"id": 1, "name": "可用"}],
                loading: true,
                dialogFormVisible: false,
                execTypeValueList: [],
                execTypeList: [{id: 1, name: '按周'}, {id: 2, name: '按顺序'}, {id: 3, name: '随机'}, {id: 0, name: '未指定'}],
                form: {
                    "messageId": 0 || this.$route.query.messageId,
                    "templateId": "",
                    "status": 1,
                    "variable": "",
                    "messageName": "",
                    "platformId": "",
                    "first": "",
                    "topColor": "",
                    "remark": "",
                    "execType": 1,
                    "execTypeValue": "",
                    "sort": 0,
                    "bottomColor": "",
                    "url": "",
                    "status": 1
                },
                formInline: {
                    "messageId": 0 || this.$route.query.messageId,
                },
                body: []
            }
        },
        //挂载时候执行
        mounted(){
            this.getList();
            this.getWeekDataList();
        },
        methods: {
            getList(){
                this.loading = true;
                getPlateMessageContentList(this.formInline).then((res) => {
                    this.loading = false;
                    this.listData = res.data.value;
                })
            },
            getWeekDataList(){
                getWeekList().then((res) => {
                    this.execTypeValueList = res.data.value;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            add(){
                this.loading = true;
                getPlateMessageContent(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.form = {
                            "messageId": res.data.value.messageId,
                            "status": 1,
                            "variable": res.data.value.variable,
                            "messageName": res.data.value.messageName,
                            "first": res.data.value.first,
                            "topColor": res.data.value.topColor,
                            "remark": res.data.value.remark,
                            "execType": 1,
                            "execTypeValue": "",
                            "sort": 0,
                            "bottomColor": res.data.value.bottomColor,
                            "url": res.data.value.url,
                        };
                        this.body = JSON.parse(res.data.value.variable)
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }

                });
                this.dialogFormVisible = true;
            },
            handleDel(row){
                if (confirm("确定删除模板:" + row.messageName + "内容吗？")) {
                    deletePlateMessageContent({messageContentId: row.messageContentId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
            handleAdd(){
                if (this.form.execTypeValue == '') {
                    this.$message({
                        showClose: true,
                        message: '执行时间必选',
                        type: 'error'
                    });
                    return;
                }
                savePlateMessageContent(this.form).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }

                });
            },
            handleEdit(row){
                this.dialogFormVisible = true;
                this.form = {
                    "messageId": row.messageId,
                    "status": row.status,
                    "variable": row.variable,
                    "messageName": row.messageName,
                    "first": row.first,
                    "topColor": row.topColor,
                    "remark": row.remark,
                    "execType": row.execType,
                    "execTypeValue": row.execTypeValue,
                    "sort": row.sort,
                    "bottomColor": row.bottomColor,
                    "url": row.url,
                    "messageContentId": row.messageContentId
                };
                this.body = JSON.parse(row.variable)
            },
            save(data){
                if (data.templateId == "") {
                    this.$message({
                        message: "请输入模板Id",
                        type: 'error'
                    });
                    return;
                }
                if (data.execTypeValue == "") {
                    this.$message({
                        message: "请选择执行时间",
                        type: 'error'
                    });
                    return;
                }
                data.variable = JSON.stringify(this.body);
                savePlateMessageContent(data).then((res) => {
                    //console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }


                });

            },

            platformProcess(row, column, cellValue) {
                for (var key in this.platformData) {
                    if (this.platformData[key].platformId == cellValue) {
                        return this.platformData[key].platformName;
                    }
                }
                //return this.randData.name;

            },
            statusProcess(row, column, cellValue) {
                for (var key in this.statusData) {
                    if (this.statusData[key].id == cellValue) {
                        return this.statusData[key].name;
                    }
                }
            },
            bodyNew(){
                this.body.push({"title": "", "value": "", "color": ""});
            },
            bodyNewDel(data){
                this.removeObjWithArr(this.body, data);
            },
            returnHistory(){
                window.history.back()
            },
            removeObjWithArr (_arr, _obj) {
                var length = _arr.length;
                for (var i = 0; i < length; i++) {
                    if (_arr[i] == _obj) {
                        if (i == 0) {
                            _arr.shift(); //删除并返回数组的第一个元素
                            return;
                        }
                        else if (i == length - 1) {
                            _arr.pop();  //删除并返回数组的最后一个元素
                            return;
                        }
                        else {
                            _arr.splice(i, 1); //删除下标为i的元素
                            return;
                        }
                    }
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/wechat/wechatTemplateMessageContent.vue